import * as ACTIONS from '../../constants/index-operations-constants';

const loadOperationsEnableStates = async (client = 'default') => {
  const filename = `init-index-components-${client}.json`;

  /* eslint-disable */
  // desactivo eslint porque pide el fetch que es algo global.
  return fetch(`../../${filename}`).then(response => {
    return response.json();
  });
};

export const updateAllOperations = payload => {
  return { type: ACTIONS.ALL_UPDATE, payload };
};

export const updateGeneric = (subgroup, operation, data) => {
  return { type: ACTIONS.GENERIC_UPDATE, payload: { subgroup, operation, data } };
};

export const initOperationWidgets = client => dispatch => {
  loadOperationsEnableStates(client).then(rsp => {
    dispatch(updateAllOperations(rsp));
  });
};
